import React from "react";

export function QSpaceFeaturedContent() {
  return (
    <div className="fqxi-shortcodes-qspaceFeaturedContent"></div>
  );
}
